export default function BrandSection() {
  return (
    <div className="tw-bg-white tw-py-11 tw-flex tw-items-center tw-justify-center tw-gap-7">
      <img
        src="/adivaa/adivaa-logo.png"
        alt="Adivaa"
        className="tw-w-36 tw-h-8 tw-object-contain"
      />
      <span className="tw-w-px tw-h-9 tw-bg-[#111]" />
      <img
        src="/adivaa/logo-dark.png"
        alt="Protega"
        className="tw-w-[126px] tw-h-[19px] tw-object-contain"
      />
    </div>
  );
}
